import { getSellerFinanceSummary, refreshSellerFinance } from '../../util/api';
import { storableError } from '../../util/errors';
import { loadData as stripeDashboardLoadData } from '../StripeDashboardPage/StripeDashboardPage.duck';

const isSellerFinanceEnabled = () => process.env.REACT_APP_SELLER_FINANCE === 'true';

// ================ Action types ================ //

export const FETCH_SUMMARY_REQUEST = 'app/SellerFinancePage/FETCH_SUMMARY_REQUEST';
export const FETCH_SUMMARY_SUCCESS = 'app/SellerFinancePage/FETCH_SUMMARY_SUCCESS';
export const FETCH_SUMMARY_ERROR = 'app/SellerFinancePage/FETCH_SUMMARY_ERROR';

export const REFRESH_REQUEST = 'app/SellerFinancePage/REFRESH_REQUEST';
export const REFRESH_SUCCESS = 'app/SellerFinancePage/REFRESH_SUCCESS';
export const REFRESH_ERROR = 'app/SellerFinancePage/REFRESH_ERROR';

// ================ Reducer ================ //

const initialState = {
  summary: null,
  fetchSummaryInProgress: false,
  fetchSummaryError: null,
  refreshInProgress: false,
  refreshError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_SUMMARY_REQUEST:
      return { ...state, fetchSummaryInProgress: true, fetchSummaryError: null };
    case FETCH_SUMMARY_SUCCESS:
      return { ...state, fetchSummaryInProgress: false, summary: payload };
    case FETCH_SUMMARY_ERROR:
      return { ...state, fetchSummaryInProgress: false, fetchSummaryError: payload };

    case REFRESH_REQUEST:
      return { ...state, refreshInProgress: true, refreshError: null };
    case REFRESH_SUCCESS:
      return { ...state, refreshInProgress: false };
    case REFRESH_ERROR:
      return { ...state, refreshInProgress: false, refreshError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchSummaryRequest = () => ({ type: FETCH_SUMMARY_REQUEST });
export const fetchSummarySuccess = summary => ({ type: FETCH_SUMMARY_SUCCESS, payload: summary });
export const fetchSummaryError = e => ({ type: FETCH_SUMMARY_ERROR, payload: e, error: true });

export const refreshRequest = () => ({ type: REFRESH_REQUEST });
export const refreshSuccess = () => ({ type: REFRESH_SUCCESS });
export const refreshError = e => ({ type: REFRESH_ERROR, payload: e, error: true });

// ================ Thunks ================ //

export const fetchSummary = () => dispatch => {
  dispatch(fetchSummaryRequest());
  return getSellerFinanceSummary()
    .then(res => {
      dispatch(fetchSummarySuccess(res));
      return res;
    })
    .catch(e => {
      dispatch(fetchSummaryError(storableError(e)));
    });
};

// On-demand refresh, then re-pull the summary so the cards update.
export const refresh = () => dispatch => {
  dispatch(refreshRequest());
  return refreshSellerFinance()
    .then(res => {
      dispatch(refreshSuccess());
      dispatch(fetchSummary());
      return res;
    })
    .catch(e => {
      dispatch(refreshError(storableError(e)));
    });
};

// ================ loadData ================ //

// The route is shared with the old StripeDashboardPage. Flag OFF => behave
// exactly like the old page (its loader creates the Stripe account session +
// page assets). Flag ON => additionally fetch the dashboard summary. The old
// loader still runs so the "Hantera betalningar" tab has its connectInstance.
export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const legacy = dispatch(stripeDashboardLoadData(params, search));
  if (!isSellerFinanceEnabled()) {
    return legacy;
  }
  return Promise.all([legacy, dispatch(fetchSummary())]);
};
